'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _containers = require('containers');

var _Link = require('react-router/lib/Link');

var _Link2 = _interopRequireDefault(_Link);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./Footer.scss');

var Footer = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(Footer, _Component);

  function Footer() {
    (0, _classCallCheck3.default)(this, Footer);
    return (0, _possibleConstructorReturn3.default)(this, (Footer.__proto__ || (0, _getPrototypeOf2.default)(Footer)).apply(this, arguments));
  }

  (0, _createClass3.default)(Footer, [{
    key: 'openContactForm',
    value: function openContactForm() {
      this.loginContact.getWrappedInstance().open();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;


      return _react2.default.createElement(
        'div',
        { className: styles.footer },
        _react2.default.createElement(
          'div',
          { className: 'homeContent' },
          _react2.default.createElement(
            'div',
            { className: styles.links },
            _react2.default.createElement(
              _Link2.default,
              { to: '/info/terms-of-service' },
              t('Terms of service')
            ),
            _react2.default.createElement(
              _Link2.default,
              { to: '/info/security' },
              t('Security')
            ),
            _react2.default.createElement(
              _Link2.default,
              { to: '/info/copyright-policy' },
              t('Copyright Policy')
            ),
            _react2.default.createElement(
              _Link2.default,
              { to: '/info/privacy-policy' },
              t('Privacy Policy')
            ),
            _react2.default.createElement(
              _Link2.default,
              { to: '/info/cookie-policy' },
              t('Cookie Policy')
            ),
            _react2.default.createElement(
              'span',
              { className: 'a', onClick: this.openContactForm },
              t('Contact Us')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.footerCopyright },
            '\xA9 2011-',
            new Date().getFullYear(),
            ' Secure Arts Ltd'
          )
        ),
        _react2.default.createElement(_containers.LoginContact, { ref: function ref(el) {
            return _this2.loginContact = el;
          } })
      );
    }
  }]);
  return Footer;
}(_react.Component), _class3.propTypes = {
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'openContactForm', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'openContactForm'), _class2.prototype)), _class2)) || _class);
exports.default = Footer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.js
// module id = 2008
// module chunks = 1